import * as React from "react";

const SvgUsersManagement = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
     <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
    <path d="M2223 5046 l-28 -24 -5 -268 -5 -267 -81 -22 c-150 -41 -296 -104
-427 -182 l-59 -36 -187 187 c-251 250 -209 251 -477 -16 -204 -202 -241 -249
-229 -291 4 -12 90 -106 192 -208 l186 -187 -37 -60 c-79 -130 -154 -314 -196
-479 l-11 -43 -264 0 -264 0 -28 -24 -28 -24 0 -311 0 -311 28 -27 c24 -25 36
-28 105 -31 l77 -4 33 67 c60 123 184 230 320 277 54 18 87 23 172 22 103 -1
135 -8 251 -58 14 -6 17 9 22 121 17 318 135 595 349 820 328 342 791 475
1251 359 348 -89 660 -343 827 -675 75 -151 130 -384 130 -556 0 -70 2 -76 18
-70 83 36 155 56 217 62 207 17 427 -106 522 -293 l38 -75 77 3 c69 3 81 6
105 31 l28 27 3 278 c2 152 0 292 -3 311 -3 18 -17 44 -30 57 l-24 24 -264 0
-264 0 -31 108 c-38 133 -86 248 -157 377 l-55 100 184 185 c101 102 187 195
191 207 12 42 -25 89 -229 291 -268 267 -226 266 -477 16 l-187 -187 -59 36
c-132 79 -268 137 -428 182 l-80 22 -5 259 c-5 268 -9 292 -50 314 -11 6 -135
10 -324 10 l-305 0 -28 -24z"/>
<path d="M2465 3880 c-523 -45 -931 -445 -995 -975 -19 -159 2 -327 62 -491
l30 -84 260 0 c244 0 260 1 252 18 -42 95 -57 162 -58 252 -1 110 12 167 63
265 65 126 193 230 334 270 75 22 219 22 294 0 143 -41 269 -143 334 -270 51
-98 64 -155 63 -265 -1 -90 -16 -157 -58 -252 -8 -17 8 -18 252 -18 l260 0 30
84 c50 136 65 226 65 376 0 198 -36 345 -127 516 -206 387 -620 611 -1061 574z"/>
<path d="M2453 2956 c-337 -110 -340 -591 -4 -696 112 -35 220 -20 316 45 232
158 202 516 -53 633 -69 31 -192 40 -259 18z"/>
<path d="M949 2600 c-101 -17 -187 -72 -244 -155 -85 -126 -85 -284 0 -410
158 -232 506 -204 631 51 26 53 29 69 29 154 0 85 -3 101 -29 154 -51 103
-153 185 -252 201 -75 12 -89 13 -135 5z"/>
<path d="M4052 2599 c-113 -19 -215 -96 -268 -205 -26 -53 -29 -69 -29 -154 0
-85 3 -101 29 -154 147 -299 579 -270 677 45 35 113 15 232 -55 328 -78 106
-219 162 -354 140z"/>
<path d="M2112 1960 c-259 -36 -470 -224 -539 -480 -16 -58 -18 -121 -18 -595
l0 -530 23 -50 c51 -111 138 -165 265 -165 l77 0 0 640 0 640 90 0 90 0 0
-640 0 -640 460 0 460 0 0 640 0 640 90 0 90 0 0 -640 0 -640 78 0 c126 0 213
54 264 165 23 50 23 54 26 520 4 511 -3 613 -44 723 -72 193 -234 340 -439
398 -52 15 -119 18 -485 20 -234 1 -454 -2 -488 -6z"/>
<path d="M500 1585 c-174 -38 -349 -174 -428 -335 -63 -126 -72 -185 -72 -465
0 -261 7 -310 56 -407 38 -75 120 -152 206 -193 120 -58 108 -109 108 460 l0
495 90 0 90 0 0 -500 0 -500 454 0 454 0 -34 68 c-19 37 -39 93 -45 125 -6 37
-9 250 -7 590 4 543 5 561 43 660 7 16 -17 17 -421 16 -326 0 -445 -4 -494
-14z"/>
<path d="M3723 1528 c20 -69 21 -101 25 -605 2 -340 -1 -553 -7 -590 -6 -32
-26 -88 -45 -125 l-34 -68 454 0 454 0 0 500 0 500 90 0 90 0 0 -496 0 -496
30 6 c99 19 234 126 284 223 49 98 56 147 56 408 0 172 -4 260 -15 309 -38
181 -172 354 -335 434 -138 68 -167 72 -646 72 l-422 0 21 -72z"/>
   </g>
  </svg>
);

export default SvgUsersManagement;
